// Light weight component to mimic MFE headers, accepts optional title
import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';

const MfeHeader = ({ styles, children, title }) => {
  return (
    <section className={styles.MfeHeader}>
      {title ? <div className={styles.MfeHeaderTitle}>{title}</div> : null}
      {children}
    </section>
  );
};

MfeHeader.propTypes = {
  styles: PropTypes.object.isRequired,
  children: PropTypes.node,
  title: PropTypes.string
};

export default themeable(MfeHeader);
